/* Festi Market — retour à la navigation depuis le devis (thèmes non publiés). */
(function () {
  'use strict';

  var KEY = 'fm_quote_return_v1';
  var MAX_AGE = 3 * 60 * 60 * 1000;
  var here = window.location;

  function localURL(value) {
    try {
      var url = new URL(value, here.href);
      return url.origin === here.origin ? url : null;
    } catch (error) {
      return null;
    }
  }

  function collectionURL(value) {
    var url = localURL(value);
    if (!url) return null;
    var match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+/i);
    if (!match) return null;
    var tail = url.pathname.slice(match[0].length);
    if (tail === '' || tail === '/') return url.pathname + url.search + url.hash;
    if (tail.indexOf('/products/') === 0) return match[0];
    return null;
  }

  function shoppingURL(value) {
    var url = localURL(value);
    if (!url) return null;
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|products|search)(?:\/|$)/i.test(url.pathname)
      ? url.pathname + url.search + url.hash
      : null;
  }

  function readState() {
    try {
      var state = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      return state && Date.now() - state.time < MAX_AGE && Date.now() >= state.time ? state : {};
    } catch (error) {
      return {};
    }
  }

  function saveState(state) {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (error) { /* Navigation native conservée. */ }
  }

  var state = readState();
  var activeCollection = collectionURL(here.href);
  var currentPage = shoppingURL(here.href);
  var fromCollection = collectionURL(document.referrer);
  if (currentPage) {
    if (activeCollection || fromCollection) state.collection = activeCollection || fromCollection;
    state.page = currentPage;
    state.time = Date.now();
    saveState(state);
  }

  function returnTarget() {
    var saved = readState();
    return collectionURL(saved.collection) || shoppingURL(saved.page) || shoppingURL(document.referrer) || '/';
  }

  function updateCartLinks() {
    var url = returnTarget();
    document.querySelectorAll('[data-fm-quote-continue]').forEach(function (link) {
      link.setAttribute('href', url);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartLinks, { once: true });
  } else {
    updateCartLinks();
  }

  // La page Samita est alimentée dynamiquement : délégation sans observer tout le DOM.
  var isQuotePage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/request-for-quote\/?$/i.test(here.pathname);
  if (!isQuotePage) return;

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('a, button, [role="button"]') : null;
    if (!target || !target.closest('.rfq_form_page, #grfq-page')) return;
    var text = (target.textContent || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
    if (!/(?:continu(?:er|ez)|poursuiv(?:re|ez)).*achat|continue shopping/.test(text)) return;
    var destination = returnTarget();
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      if (target.tagName === 'A') target.setAttribute('href', destination);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination);
  }, true);
}());